import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { dashboardQKeys } from "@hooks/queries/dashboard/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useRetryPayout = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post(`payouts/${id}/retry`);
      return data;
    },
    onSuccess: (data) => {
      if (data.status === "failed") {
        notifications.show({
          title: "Retry Failed",
          message: data.failure_reason || "The payout retry failed again.",
          color: "red",
          autoClose: 8000,
        });
      } else {
        notifications.show({
          title: "Success",
          message: "Payout retry processed successfully",
          color: "green",
        });
      }
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payouts(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payoutSummary(),
      });
    },
    onError: (res: any) => {
      console.error("[From Retry Payout Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
